<template>
  <v-dialog
      v-model="value"
      persistent
      content-class="full-size"
      :transition="false"
  >
    <v-layout align-center justify-center row fill-height>
      <v-progress-circular
          :size="150"
          :width="7"
          color="orange"
          indeterminate
      ></v-progress-circular>
    </v-layout>

  </v-dialog>
</template>

<script>

export default {
  name: 'Loader',
  props: {
    value: {
      type: Boolean,
      required: true,
    }
  }
}
</script>

<style lang="stylus">

.full-size
  height 100vh !important
  max-height: 100% !important
  width  100vw !important
  margin 0

</style>